var React = require('react');

function FbFooter (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11 0C4.92487 0 0 4.95022 0 11.0254C0 16.7423 4.36121 21.463 9.93812 21.9999V14.0243H7.9998V11.8227H9.93812V10.6118C9.93812 9.1441 10.3297 8.01068 11.1129 7.21159C11.896 6.41249 12.9925 6.01294 14.4021 6.01294C14.9034 6.01294 15.4359 6.08633 15.9998 6.2331L15.9293 8.557C15.616 8.49177 15.2519 8.45916 14.8368 8.45916C13.4741 8.45916 12.7927 9.18894 12.7927 10.6485V11.8227H15.3772V14.0243H12.7927V21.9046C18.0152 21.0445 22 16.49 22 11.0254C22 4.95022 17.0751 0 11 0Z","fill":"currentColor"}));
}

FbFooter.defaultProps = {"viewBox":"0 0 22 22","fill":"none"};

module.exports = FbFooter;

FbFooter.default = FbFooter;
